var exports = {
  "U": "x234b8571--35f059--content-container",
  "b": "x234b8571--35f059--website-link-container",
};

module.exports = exports;
